// @flow
import Merge from './component'

export default Merge
